import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import { fetchSurvey, updateSurvey, resetSurvey } from 'actions/survey';
import { EditSurvey } from 'views';

const mapStateToProps = (state, ownProps) => ({
  survey: state.survey,
  surveyId: ownProps.match.params.id
});

const mapDispatchToProps = dispatch => ({
  actions: {
    ...bindActionCreators(
      {
        fetchSurvey,
        updateSurvey,
        push
      },
      dispatch
    ),
    onUnmount: () => {
      dispatch(resetSurvey());
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSurvey);
